<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row form-group">
        <div class="col-md-12">
          <label class="col-form-label control-label">{{
            $t('user.roleName')
          }}</label>
          <div id="role-group" class="ts-border ts-border-gray-300 ts-rounded">
            <ul class="ts-reset ts-px-4 ts-py-2 ts-h-full">
              <li v-for="role in roles" :key="role.id">
                <ts-checkbox v-model="model.roles" :value="role.id">{{
                  role.name == '*' ? 'Admin' : role.name
                }}</ts-checkbox>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
export default {
  name: 'roleComponent',
  props: ['value'],
  data() {
    return {
      loading: false,
      roles: [],
      model: {}
    }
  },
  created() {
    this.model = this.value
    this.fetchRole()
  },
  methods: {
    fetchRole() {
      this.loading = true
      this.$store
        .dispatch('user/getRole')
        .then(response => {
          this.roles = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="css" scoped>
#role-group {
  min-height: 80px;
  max-height: 100px;
  overflow-y: scroll;
}
</style>
